/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'components/link'
import { RegItemShape } from 'registry/lib/prop-types'

const StoreIcon = ({ storeIconName, className }) => (
  <span
    className={classNames(
      'icon-offer',
      `icon-offer-${storeIconName}`,
      className
    )}
  />
)

StoreIcon.propTypes = {
  storeIconName: PropTypes.string.isRequired,
  className: PropTypes.string,
}

StoreIcon.defaultProps = {
  className: undefined,
}

const StoreLink = ({
  url,
  viglinkEnabled,
  storeIconName,
  storeDisplayName,
  openRedirectModal,
  openReservationModal,
  children,
  isContributorView,
  regItem,
  responsive,
}) => {
  const onRedirectSuccess = () => {
    if (regItem && !regItem.disableReservations) {
      openReservationModal()
    }
  }

  if (
    storeDisplayName === 'Babylist' ||
    isContributorView ||
    !openRedirectModal ||
    !openReservationModal ||
    !regItem
  ) {
    return (
      <Link
        url={url}
        className={classNames('link-offer mrs', {
          'offer-responsive': responsive,
        })}
        newWindow
        rel={`nofollow${viglinkEnabled ? '' : ' norewrite'}`}
        onClick={() => {
          if (storeDisplayName === 'Babylist' && !isContributorView) {
            onRedirectSuccess()
          }
        }}
        onKeyDown={() => {
          if (storeDisplayName === 'Babylist' && !isContributorView) {
            onRedirectSuccess()
          }
        }}
      >
        <div className="offer-layout-wrapper">
          <StoreIcon storeIconName={storeIconName} />
          <span className="offer-store">{storeDisplayName}</span>
          <span className="offer-price">{children}</span>
        </div>
      </Link>
    )
  }

  return (
    <Link
      className="link-offer mrs"
      style={{ width: '100%', cursor: 'pointer' }}
      onClick={() =>
        openRedirectModal({
          url,
          storeDisplayName,
          onRedirectSuccess,
        })
      }
      onKeyDown={() =>
        openRedirectModal({
          url,
          storeDisplayName,
          onRedirectSuccess,
        })
      }
    >
      <div className="offer-layout-wrapper">
        <StoreIcon storeIconName={storeIconName} />
        <span className="offer-store">{storeDisplayName}</span>
        <span className="offer-price">{children}</span>
      </div>
    </Link>
  )
}

StoreLink.propTypes = {
  children: PropTypes.node.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  openReservationModal: PropTypes.func,
  storeIconName: PropTypes.string.isRequired,
  storeDisplayName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  viglinkEnabled: PropTypes.bool.isRequired,
  isContributorView: PropTypes.bool,
  regItem: PropTypes.shape(RegItemShape),
}

StoreLink.defaultProps = {
  isContributorView: false,
  openReservationModal: null,
  regItem: null,
}

const StoreDisplay = ({ storeIconName, storeDisplayName, children }) => (
  <div className="offer-layout-wrapper">
    <StoreIcon storeIconName={storeIconName} />
    <span className="offer-store">{storeDisplayName}</span>
    <span className="offer-price">{children}</span>
  </div>
)

StoreDisplay.propTypes = {
  storeIconName: PropTypes.string.isRequired,
  storeDisplayName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const Offer = ({ decorator, disableLink, ...rest }) => {
  let display
  if (disableLink) {
    display = <StoreDisplay {...rest} />
  } else {
    display = <StoreLink {...rest} />
  }
  return <div className="flex-row">{decorator(display)}</div>
}

export const offerProps = {
  id: PropTypes.number,
  disableLink: PropTypes.bool,
  url: PropTypes.string.isRequired,
  normalUrl: PropTypes.string.isRequired,
  openRedirectModal: PropTypes.func,
  openReservationModal: PropTypes.func,
  regItem: PropTypes.shape(RegItemShape),
  storeDisplayName: PropTypes.string.isRequired,
  storeIconName: PropTypes.string.isRequired,
  isBabylist: PropTypes.bool,
  isContributorView: PropTypes.bool,
  viglinkEnabled: PropTypes.bool.isRequired,
  decorator: PropTypes.func,
}

Offer.propTypes = offerProps

Offer.defaultProps = {
  decorator: (component) => component,
  disableLink: false,
  id: undefined,
  isBabylist: false,
  isContributorView: false,
  regItem: null,
  openRedirectModal: null,
  openReservationModal: () => {},
}

export default Offer
